<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="a-day-out">
<h1>8. A Day Out</h1>
<p>Sunday morning was bright but hazy, Clary and Jasmine set off through the tunnels to another discrete entrance, this one leading directly into an underground station, from there it was a short trip to Marylebone and the main line to Northampton, the journey just long enough for a leisurely cup of tea in the buffet car.</p>
<p>Taking a taxi from the station to Jasmine's parents' house where after welcomes and introductions, over Sunday lunch, Jasmine told her parents about her new job. The official version.</p>
<p>Enjoying an after-dinner cup of tea, Jasmine's and Clary's mobile phones went off together.</p>
<p>“Sounds like trouble,” said Clary, reaching for their phones.</p>
<p>Jasmine's call was from Roger.</p>
<p>“Jazz, can you talk?”</p>
<p>“Yes Roger, no problem, what's happened?”</p>
<p>“BASF have been in touch about that chemical, the one we are monitoring.”</p>
<p>“Where is it?”</p>
<p>“There is half a ton of it on a ship heading for Norfolk, Virginia. It was due to dock this morning the third of July. We're setting up an emergency meeting with the Americans and need you here. How far from the county police headquarters are you?”</p>
<p>“Five minutes, ten at the outside.”</p>
<p>“Get there soonest. You are being picked up. Clary is getting the briefing from Henry, now get moving.”</p>
<p>“Moving now Roger, bye.”</p>
<p>Cutting the call, Jasmine looked across at Clary who rolled her eyes and was just finishing her call.</p>
<p>“Dad, sorry but this is an emergency, can you get us to the Police headquarters as fast as possible?”</p>
<p>“Why Jasmine, what's happening?”</p>
<p>“Sorry I can't tell you, but we are in a big hurry. Please, Dad. This is important!” Her father went to get the car started as Jasmine said goodbye to her mother.</p>
<p>“Sorry, Mum. I'll be back and tell you about it.”</p>
<p>Sunday traffic made the journey seem intolerably slow yet it took no more than seven minutes.</p>
<p>“Mr Salt, if you go into the police vehicle entrance, we need to go to the sports field at the back of the building, it should be signposted,” Clary directed.</p>
<p>Seeing the sign, her father drove round to the rear of the main building pulling up by the football pitch as a large army helicopter swooped into view and made a swift landing. No gentle approach; this was in a hurry. The few people in the area, stopping to watch in amazement.</p>
<p>“Thanks, Dad, I've always wanted to have a ride in one of these things.”</p>
<p>The side door of the machine opened and they were beckoned forward with an indication that they should keep low, under the rotors the noise and wind battering them. Reaching the door, they were pulled inside and plonked into jump seats. The door closed as the helicopter lifted off, leaving stomachs behind.</p>
<p>With seat belts fastened, headsets were passed across and they could hear again.</p>
<p>“Afternoon ladies, sorry about the rather rough ride, but they tell me we are in a hurry, so hang on. Not much of a view for you I'm afraid, we're following the M1 which is pretty boring from any angle. We're flying low but high enough to keep out of the traffic.”</p>
<p>“Are we expecting trouble?” Clary asked looking at the large chain gun swivelled against the bulkhead with what looked like live ammunition in the feed.</p>
<p>“Apologies for the artillery, as the nearest fast transport to you we were volunteered.”</p>
<p>“Sorry if we spoilt your afternoon duck shooting,” quipped Jasmine hearing a laugh from somewhere.</p>
<p>“Nearly there, we are going to drop you on the American embassy roof, just hope someone has told them we're coming, trigger happy bunch Americans, might get the wrong idea if they haven't.”</p>
<p>“Don't worry, they can't hit anything, like the ’A' team' they are,” said another voice raising more laughter, the by play continuing until another voice cut in.</p>
<p>“Landing in one minute.”</p>
<p>“Thanks for the lift gentlemen,” said Jasmine.</p>
<p>“Gentlemen, she called us, you're more than welcome, hopefully see you again for a smoother ride sometime.”</p>
<p>“You never know, bye guys.”</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch012.vue?69ea6ed3